export const AMENITY_LIST_ACTION = "AMENITY_LIST_ACTION";
export const AMENITY_LIST_SUCCESS = "AMENITY_LIST_SUCCESS";
export const AMENITY_LIST_FAIL = "AMENITY_LIST_FAIL";
export const AMENITY_DELETE_TRANSLATE_SUCCESS = "AMENITY_DELETE_TRANSLATE_SUCCESS";

export const AMENITY_DETAIL_ACTION = "AMENITY_DETAIL_ACTION";
export const AMENITY_DETAIL_DELETE_ACTION = "AMENITY_DETAIL_DELETE_ACTION";
export const AMENITY_DETAIL_SUCCESS = "AMENITY_DETAIL_SUCCESS";
export const AMENITY_DETAIL_FAIL = "AMENITY_DETAIL_FAIL"

export const AMENITY_DETAIL_UPDATE_ACTION = "AMENITY_DETAIL_UPDATE_ACTION";
export const AMENITY_DETAIL_CREATE_ACTION = "AMENITY_DETAIL_CREATE_ACTION";

export const AMENITY_CREATE_TRANSLATE_ACTION = "AMENITY_CREATE_TRANSLATE_ACTION";
export const AMENITY_UPDATE_TRANSLATE_ACTION = "AMENITY_UPDATE_TRANSLATE_ACTION";
export const AMENITY_DELETE_TRANSLATE_ACTION = "AMENITY_DELETE_TRANSLATE_ACTION";

export const AMENITY_CREATE_TRANSLATE_SUCCESS = "CATEGORY_CREATE_TRANSLATE_SUCCESS";
export const AMENITY_UPDATE_TRANSLATE_SUCCESS = "AMENITY_UPDATE_TRANSLATE_SUCCESS";
export const AMENITY_FAIL = "AMENITY_FAIL";